import { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../store';
import { IAdminEvent } from '../../store/admin/events/store';

export const useGetAdminEvent = (eventId: number | string | undefined) => {
  const [event, setEvent] = useState<IAdminEvent>();

  const { adminEvents } = useContext(GlobalContext);

  useEffect(() => {
    if (eventId && adminEvents[Number(eventId)]) {
      setEvent(adminEvents[Number(eventId)]);
    }
  }, [adminEvents, eventId]);

  return event;
};
